import React, { useState, useEffect } from "react";
import { useModal } from "../context/ModalContext";
import ModalComponent from "../components/ModalComponent";
// import SoftwareAuditModal from "../components/SoftwareAuditModal";

export default function CancellationPolicy() {
  // const { showModal, handleClose } = useModal();

  useEffect(() => {
    document.title = "Cancellation Policy - Plural Code Technologies"; // Quick solution
  }, []);
  return (
    <div>
      <main className="wrapper">
        <section className="page-hero-sec administration-sec">
          <div className="container">
            <div className="page">
              <div className="translations-content-container">
                <div className="container">
                  <div
                    className="tab-content translations-content-item en visible"
                    id="en"
                  >
                    <h1 className="tc-primary head-font text-center pb-5">
                      Cancellation & Refund Policy
                    </h1>

                    <div className="terms-content">
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Effective Date:</strong> May 1, 2025
                      </p>

                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        Thank you for registering for our webinars at{" "}
                        <b>Plurl Code Technologies</b>{" "}
                        {/* <span className="fs-14">
                          (part of <b>Sarentu IT Solutions Pvt. Ltd.</b>)
                        </span> */}
                        {" "}
                        We understand that sometimes plans change, and we've
                        outlined our cancellation and refund policy below.
                      </p>

                      <h2 className="tc-primary head-font py-3">
                        1. Cancellation by Participant
                      </h2>
                      <ul>
                        <li className="tc-primary fs-17 py-1">
                          {" "}
                          Cancellations must be made in writing via email to
                          info@pluralcode.com.
                        </li>
                        <li className="tc-primary fs-17 py-1">
                          If you cancel your webinar registration at least 10
                          days before the scheduled webinar, you will be
                          eligible for a full refund minus any processing fees.
                        </li>
                        <li className="tc-primary fs-17 py-1">
                          Cancellations made less than 10 days before the
                          webinar are non-refundable.
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">
                        2. No-Show Policy
                      </h2>
                      <ul>
                        <li className="tc-primary fs-17py-1">
                          {" "}
                          If you do not attend the webinar and have not notified
                          us in advance, no refund will be issued
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">
                        3. Rescheduling Requests
                      </h2>

                      <ul>
                        <li className="tc-primary fs-17 py-1">
                          {" "}
                          If you are unable to attend, you may request to
                          transfer your webinar registration to a future session
                          (subject to availability).
                        </li>
                        <li className="tc-primary fs-17 py-1">
                          {" "}
                          Rescheduling requests must be made at least 10 days
                          before the webinar date
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">
                        4. Cancellation by Organizer
                      </h2>

                      <ul>
                        <li className="tc-primary fs-17 py-1">
                          We reserve the right to cancel or reschedule webinars
                          due to unforeseen circumstances.
                        </li>
                        <li className="tc-primary fs-17 py-1">
                          {" "}
                          In such cases, participants will be offered a full
                          refund or the option to attend a rescheduled session.
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">
                        5. Refund Process
                      </h2>
                      <ul>
                        <li className="tc-primary fs-17py-1">
                          {" "}
                          Refunds (if applicable) will be processed within 7
                          business days to the original payment method
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">6. Contact</h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        If you have any questions about this policy, please
                        contact us at:
                      </p>
                      <ul>
                        <li className="tc-primary fs-17 py-1">
                          Email:{" "}
                          <a
                            href="mailto:info@pluralcode.com"
                            className="text-blue-600 hover:underline"
                          >
                            info@pluralcode.com
                          </a>
                        </li>
                        <li className="tc-primary fs-17 py-1">
                          Phone: +919958920231
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* {showModal && (
        <SoftwareAuditModal handleClose={handleClose} showModal={showModal} />
      )} */}
    </div>
  );
}
